
import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { sagas as sagasMap } from '../../map';
import { sagas as sagasMultiScene } from '../../multiscene';
import { sagas as sagasMeasurement } from '../../measurement';
import appGetActions from '../../app/saga';
import { getMapLayers } from '../../project';
import { MultiScene, componentDidUpdateInitViewFromUrl } from '../../multiscene';
import getAppModules from './getAppModules';
import DialogObjectInfo from './DialogObjectInfo';

/**
 * Viewer containing 3D scene window.
 *
 * @reactProps {Object} projectDefinition - project definition
 * @reactProps {Object} map - actual map state
 */
class MultiSceneBasicViewer extends Component {

    classNames = mergeStyleSets({
    });

    constructor(props) {
        super(props);
        this._multiSceneComponent = null;
    }

    componentDidUpdate(prevProps) {
        componentDidUpdateInitViewFromUrl(
            this._multiSceneComponent, this.props, prevProps
        );
    }

    getAppModules() {
        return getAppModules(this.props.projectDefinition);
    }

    handleObjectInfo = async (layerId, attributes) => {
        await DialogObjectInfo.show(
            getMapLayers(this.props.project),
            layerId,
            attributes,
            this.props.projectDefinition.app
        );
    }

    render() {
        return (
            <Stack horizontal styles={{root: {height: '100%'}}} tokens={{childrenGap: 0, padding: 5}}>
                {this.renderMultiScene()}
            </Stack>
        );
    }

    renderMultiScene() {
        return (
            <Stack.Item grow={1}>
                <MultiScene
                    ref={element => this._multiSceneComponent = element}
                    appConfig={this.props.projectDefinition.app}
                    projectUrl={this.props.projectDefinition.multiSceneProject.url}
                    initialized={this.props.multiScene.initialized}
                    mode={this.props.multiScene.mode}
                    initialMode="points"
                    commands={this.props.multiScene.commands}
                    layers={this.props.map.layers}
                    multiSceneActions={this.props.multiSceneActions}
                    measurementActions={this.props.measurementActions}
                    showHomeScene={true}
                    onObjectInfo={this.handleObjectInfo}
                />
            </Stack.Item>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        mapActions: sagasMap.getActions(dispatch),
        multiSceneActions: sagasMultiScene.getActions(dispatch),
        measurementActions: sagasMeasurement.getActions(dispatch),
        appActions: appGetActions(dispatch)
    };
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        auth: state.auth,
        urlParams: state.app.urlParams,
        multiScene: state.multiScene.multiScene,
        measurement: state.measurement,
        project: state.project
    };
}

const ConnectedMultiSceneBasicViewer = connect(mapStateToProps, mapDispatchToProps)(MultiSceneBasicViewer);

export default ConnectedMultiSceneBasicViewer;
